// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39kgk","right":"styles_right__2ZZvf"};